import styled from 'styled-components';

export const OverlayHeroSection = styled.section`
  position: relative;
  width: 100vw;
  height: 60vh;
  min-height: 420px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 50vh;
    min-height: 360px;
  }
`;

export const OverlayHeroImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-position: center;
`;

export const OverlayHeroGradient = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ gradient }) =>
    gradient || 'linear-gradient(to top, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.2))'};
`;

export const OverlayHeroContent = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 2rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-width: 768px) {
    padding: 0 1.5rem 2rem;
  }
`;
